import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import { useAuth } from 'contexts/auth'
import React, { useState } from 'react'
import { useStyles } from './styles'

interface EmailPreviewProps {
  baseLogo: string
  mainColor: string
}

const EmailPreview = ({ baseLogo, mainColor }: EmailPreviewProps) => {
  const [activeButton, setActiveButton] = useState(0)

  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.buttonBox}>
        <Button
          variant={activeButton == 0 ? 'contained' : 'outlined'}
          size='small'
          className={classes.button}
          onClick={() => setActiveButton(0)}
        >
          Convite
        </Button>

        <Button
          variant={activeButton == 1 ? 'contained' : 'outlined'}
          size='small'
          className={classes.button}
          onClick={() => setActiveButton(1)}
        >
          Confirmação do email
        </Button>

        <Button
          variant={activeButton == 2 ? 'contained' : 'outlined'}
          size='small'
          className={classes.button}
          onClick={() => setActiveButton(2)}
        >
          Boas Vindas
        </Button>
      </Box>

      {activeButton === 0 && <EmailInvite logo={baseLogo} />}
      {activeButton === 1 && (
        <EmailConfirm
          logo={baseLogo}
          mainColor={mainColor}
        />
      )}
      {activeButton === 2 && <EmailWelcome logo={baseLogo} />}
    </Box>
  )
}

const EmailInvite = ({ logo }: { logo: string }) => {
  const classes = useStyles()
  const { user } = useAuth()

  return (
    <Box className={classes.centerBox}>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          sx={{ padding: '0.5rem 4rem' }}
        >
          <Grid
            item
            xs={12}
            className={classes.formBox}
          >
            <img
              src={logo}
              alt='email-preview'
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Box className={classes.paperContent}>
              <Typography variant='h6'>A {user && user.name} está te convidando para acessar a plataforma</Typography>
              <Typography variant='inherit'>Prezado Cliente,</Typography>
              <Typography variant='inherit'>
                É com grande entusiasmo que convido você e sua equipe para se juntarem à plataforma Conducco, um
                benefício exclusivo para os clientes da Corretora.
              </Typography>
              <Typography variant='inherit'>
                A partir de agora, o processo de envio mensal de formulários para registrar altas e baixas será
                automatizado. A Conducco acessará diretamente os registros do e-Social, identificando os funcionários
                admitidos e demitidos no período vigente.
              </Typography>
              <Typography variant='inherit'>
                Os benefícios são inúmeros e impactantes:
                <ul>
                  <li>
                    <strong>Redução do trabalho operacional:</strong> Automatizamos a leitura dos dados dos funcionários
                    para inclusão e exclusão no seguro de vida.
                  </li>
                  <li>
                    <strong>Redução de riscos:</strong> Nossa plataforma executa validações que garantem a segurança das
                    apólices.
                  </li>
                  <li>
                    <strong>Segurança nos dados:</strong> Total aderência à LGPD, assegurando a confidencialidade no
                    tratamento dos dados, oferecendo mais segurança para sua empresa.
                  </li>
                </ul>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}

const EmailConfirm: React.FC<{ logo: string; mainColor: string }> = ({ logo, mainColor }) => {
  const classes = useStyles()

  return (
    <Box className={classes.centerBox}>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          sx={{ padding: '0.5rem 4rem' }}
        >
          <Grid
            item
            xs={12}
            className={classes.formBox}
          >
            <img
              src={logo}
              alt='email-preview'
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Box className={classes.paperContent}>
              <Typography variant='h6'>Token de verificação de e-mail</Typography>
              <Typography variant='inherit'>Olá, Cliente</Typography>
              <Typography variant='inherit'>
                Obrigado por se cadastrar na nossa plataforma! Para ativar sua conta, precisamos verificar o seu
                endereço de e-mail.
              </Typography>
              <Typography variant='inherit'>Seu código de verificação é:</Typography>

              <Typography
                variant='h5'
                sx={{ color: `#${mainColor}` }}
              >
                429648
              </Typography>

              <Typography variant='inherit'>
                Por favor, insira este código na caixa apropriada em nosso site para confirmar seu endereço de e-mail e
                ativar sua conta.
              </Typography>
              <Typography variant='inherit'>
                Se você não se cadastrou em nossa plataforma, por favor, ignore este e-mail.
              </Typography>
              <Typography variant='inherit'>Obrigado!</Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}

const EmailWelcome: React.FC<{ logo: string }> = ({ logo }) => {
  const classes = useStyles()

  return (
    <Box className={classes.centerBox}>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          sx={{ padding: '0.5rem 4rem' }}
        >
          <Grid
            item
            xs={12}
            className={classes.formBox}
          >
            <img
              src={logo}
              alt='email-preview'
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Box className={classes.paperContent}>
              <Typography variant='h6'>Prezado Cliente,</Typography>
              <Typography variant='inherit'>
                Seja muito bem-vindo à Conducco, sua nova aliada na busca por eficiência operacional e automação de
                processos!
              </Typography>
              <Typography variant='inherit'>
                Estamos empolgados em tê-lo a bordo e queremos garantir que você aproveite ao máximo nossa plataforma
                IpaaS.
              </Typography>

              <Typography variant='inherit'>
                Aqui estão alguns pontos destacados para começar com o pé direito:
                <ol type='1'>
                  <li>
                    <strong>Automatização Simplificada:</strong> Desfrute da facilidade de automatizar processos,
                    reduzindo o tempo gasto em tarefas repetitivas e direcionando seus esforços para o que realmente
                    importa.
                  </li>

                  <li>
                    <strong>Eficiência Operacional:</strong> A Conducco foi projetada para otimizar suas operações.
                    Explore nossas funcionalidades e descubra como podemos impulsionar a produtividade da sua equipe.
                  </li>

                  <li>
                    <strong>Segurança em Primeiro Lugar:</strong> Sua segurança é nossa prioridade. Conte com uma
                    arquitetura robusta para proteger suas informações e garantir a conformidade em todos os níveis.
                  </li>

                  <li>
                    <strong>Suporte Especializado:</strong> Estamos aqui para ajudar! Caso tenha dúvidas ou precise de
                    assistência, nossa equipe de suporte está pronta para oferecer a orientação necessária.
                  </li>
                </ol>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}

export default EmailPreview
